import {STATES} from "../framework/src/states/states";

class States {

    constructor(commander) {
    }


    move(reel, shift){
    }

    accUp(reel) {

    }

    accDown(reel) {
    }

    spin(data) {
        let reel = data.reel;

        for (let symbol of reel._spinSymbols) {
            this.blurSymbol(symbol);
        }

        for (let symbol of reel._resSymbolsTmp) {
            this.blurSymbol(symbol);
        }
    }

    stopping(reel) {
    }

    brakeDown(data) {
        let reel = data.reel;

        if (data.isForceStopping()) {
            if (!reel.getId()) {
                this.audio.playTrack("reel_Stop");
            }
        } else {
            this.audio.playTrack("reel_Stop");
        }
        for (let symbol of reel.getSpinSymbols()) {
            this.unblurSymbol(symbol);
        }
        for (let symbol of reel.getResSymbols()) {
            this.unblurSymbol(symbol);
            if (symbol.name === "symbol_Wild") {
                this.audio.playTrack("symbol_Wild");
            }
        }
    }

    brakeUp(reel) {
    }


    stop(data) {
        if (data.reel.getId() === 2 && !this.game.isAutoRun()) {
            this.states.setState(STATES.FORCESPIN);
        }
    }
}

export default States;
